var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "type=medium"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.13597 5.8567C3.13597 5.84216 3.13597 5.83126 3.13597 5.82399C3.13597 5.81672 3.13597 5.80582 3.13597 5.79128C3.13597 5.68951 3.11372 5.59502 3.06922 5.50779C3.02472 5.42056 2.97281 5.34787 2.91347 5.28972L1.2225 3.3053V3H6.45117L10.4784 11.6791L14.0161 3H19V3.3053L17.5538 4.65732C17.5093 4.6864 17.4722 4.73001 17.4425 4.78816C17.4129 4.84631 17.398 4.91173 17.398 4.98442C17.398 4.99896 17.398 5.00986 17.398 5.01713C17.398 5.0244 17.398 5.03531 17.398 5.04984V14.972C17.398 14.972 17.398 14.9792 17.398 14.9938C17.398 15.0083 17.398 15.0228 17.398 15.0374C17.398 15.0955 17.4129 15.1537 17.4425 15.2118C17.4722 15.27 17.5093 15.3209 17.5538 15.3645L18.9555 16.7165V17H11.9023V16.7165L13.3486 15.3209C13.4227 15.2627 13.4672 15.2118 13.4821 15.1682C13.4969 15.1246 13.5043 15.0447 13.5043 14.9283V6.90343L9.45488 16.9782H8.92089L4.20396 6.90343V13.6636C4.18912 13.7944 4.20396 13.9289 4.24845 14.067C4.29295 14.2051 4.36712 14.325 4.47095 14.4268L6.36218 16.6729V16.9782H1V16.6729L2.89122 14.4268C2.96539 14.3541 3.02472 14.2632 3.06922 14.1542C3.11372 14.0452 3.13597 13.9325 3.13597 13.8162C3.13597 13.7871 3.13597 13.758 3.13597 13.729C3.13597 13.6999 3.13597 13.6708 3.13597 13.6417V13.6636V5.8567Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.43bae67a15014a58022f37b69cbd3db6.svg";
export { ForwardRef as ReactComponent };